<template>
  <quill-editor v-model="content" :options="options" @blur="$emit('blur')" @focus="$emit('focus')"
                @ready="$emit('ready')" @change="onChange"/>
</template>

<script>
import {quillEditor} from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      content: this.value,
      options: {
        placeholder: this.placeholder,
        theme: this.theme,
        readOnly: this.readOnly,
        modules: this.modules
      }
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('editor.placeholder');
      },
    },
    theme: {
      type: String,
      default: 'snow'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modules: {
      type: Object,
      default: function () {
        return {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'color': []}, {'background': []}],
            [{'font': []}],
            [{'align': []}],
            ['clean']
          ]
        };
      }
    }
  },
  watch: {
    content(currentValue) {
      this.$emit('input', currentValue);
    }
  },
  methods: {
    onChange({quill, html, text}) {
      this.$emit('change', {quill, html, text});
    }
  }
};
</script>